import React from 'react';
import Relay from 'react-relay';
import { css } from 'glamor';

import Picture from './Picture';
import UserPictureFallback from './UserPictureFallback';
import VerifiedBadge from 'depop/components/badges/VerifiedBadge';

class UserPicture extends React.Component {
  props: {
    user: Object,
    compact: ?Boolean,
    onClick: (event: React.SyntheticEvent) => void,
  };

  render() {
    const { user, onClick, compact } = this.props;
    const { picture } = user;

    return (
      <div
        {...css({
          display: 'block',
          width: '100%',
          paddingBottom: '100%',
          position: 'relative',
        })}
        onClick={onClick}>
        <div
          {...css({
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            overflow: 'hidden',
          })}>
          {user.isVerified && <VerifiedBadge compact={compact} />}
          <div {...css({ borderRadius: '50%', border: '1px #eee solid', position: 'relative', zIndex: 0 })}>
            {picture && picture.formats && picture.formats.length > 0
              ? <Picture picture={picture} rounded />
              : <UserPictureFallback user={user} />}
          </div>

        </div>
      </div>
    );
  }
}

export default Relay.createContainer(UserPicture, {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${UserPictureFallback.getFragment('user')}
        isVerified
        initials
        picture {
          formats {
            url
          }
          ${Picture.getFragment('picture')}
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/images/UserPicture.js